import { MagnifyingGlass } from "@phosphor-icons/react";
import { useMemo, useState } from "react";
import { HashLoader } from "react-spinners";
import ProductItem from "../../components/ProductItem";
import useProducts from "../../hooks/useProducts";

const PRODUCTS_PER_PAGE = 20;

const Products = () => {
  const { products, isLoading } = useProducts();
  const [visibleCount, setVisibleCount] = useState(PRODUCTS_PER_PAGE);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts = useMemo(() => {
    const q = searchTerm.toLowerCase();
    const productItems = products?.data ?? [];

    return productItems.filter((product) =>
      [product.name, product.description]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(q)
    );
  }, [products?.data, searchTerm]);

  const visibleProducts = filteredProducts.slice(0, visibleCount);
  const canLoadMore = visibleCount < filteredProducts.length;

  return (
    <div className="p-10 px-5 md:px-10 flex flex-col gap-8">
      <div className="flex flex-col gap-2">
        <h1 className="text-4xl font-medium">Products</h1>
        <div className="text-gray-500">
          Browse products listed by Visaro marketplace merchants.
        </div>
      </div>

      <div className="flex items-center gap-2 px-4 border border-gray-300 shadow rounded-lg focus-within:outline w-full max-w-md">
        <MagnifyingGlass size={20} />
        <input
          placeholder="Search products"
          name="search"
          type="search"
          value={searchTerm}
          onChange={(event) => {
            setSearchTerm(event.target.value);
            setVisibleCount(PRODUCTS_PER_PAGE);
          }}
          className="focus:outline-none py-3 text-sm w-full"
        />
      </div>

      {isLoading ? (
        <div className="py-20 flex items-center justify-center flex-col gap-5">
          <HashLoader size={30} />
          <div className="text-sm animate-pulse text-center">
            Loading Products
          </div>
        </div>
      ) : visibleProducts.length > 0 ? (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-10">
          {visibleProducts.map((product) => (
            <ProductItem product={product} key={product.id} />
          ))}
        </div>
      ) : (
        <div className="py-20 text-center text-gray-500">
          No products found.
        </div>
      )}

      {canLoadMore && (
        <button
          type="button"
          onClick={() =>
            setVisibleCount((currentCount) => currentCount + PRODUCTS_PER_PAGE)
          }
          className="mx-auto p-3 px-5 text-sm rounded-lg font-medium bg-deepBlue text-white"
        >
          Load more products
        </button>
      )}
    </div>
  );
};

export default Products;
